var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupons({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 2.91669L15 1.66669L13.75 2.91669L12.5 1.66669L11.25 2.91669L10 1.66669L8.75 2.91669L7.5 1.66669L6.25 2.91669L5 1.66669V13.3333H2.5V15.8333C2.5 17.2167 3.61667 18.3333 5 18.3333H15C16.3833 18.3333 17.5 17.2167 17.5 15.8333V1.66669L16.25 2.91669ZM12.5 16.6667H5C4.54167 16.6667 4.16667 16.2917 4.16667 15.8333V15H12.5V16.6667ZM15.8333 15.8333C15.8333 16.2917 15.4583 16.6667 15 16.6667C14.5417 16.6667 14.1667 16.2917 14.1667 15.8333V13.3333H6.66667V4.16669H15.8333V15.8333Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.83331H7.5V7.49998H12.5V5.83331Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.83331H13.3333V7.49998H15V5.83331Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.33331H7.5V9.99997H12.5V8.33331Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.33331H13.3333V9.99997H15V8.33331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupons);
export default __webpack_public_path__ + "static/media/Cupons.9187c837614e4777b0f1c8a46f09c669.svg";
export { ForwardRef as ReactComponent };